import { EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Iresult, ProcessRunService } from '../../shared/process-run.service';

@Component({
  selector: 'app-process-result',
  templateUrl: './process-result.component.html',
  styleUrls: ['./process-result.component.css']
})
export class ProcessResultComponent implements OnInit {
  displayedColumns: string[] = ['No', 'Client', 'Success', 'Message', 'dload'];
  @Input() appName: string;
  @Input() inprogress: boolean;
  dataSource: MatTableDataSource<Iresult>;
  @Input() result: Iresult[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(private prs: ProcessRunService) {
    
  }
  scrollToBottom(): void {
    setTimeout(() => {
      //console.log(document.getElementById('paginator_res'))
      document.getElementById('paginator_res').scrollIntoView({ block: 'end', behavior: 'smooth' });
    },500)

   
  }

  openFile(file: string) {
    if (file) {
    let o = window.location.origin + "/";
      window.open(o +"CSVFiles/Tracker/" + file, '_blank');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  colorFOrRow(msg: string, success: boolean) {
    if (msg == 'In-Progress') {
      return '#ffc107';
    } else if (success) {
      return 'green';
    } else {
      return 'red';
    }
  }

  prepareData() {
    this.dataSource = new MatTableDataSource(this.result);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.scrollToBottom();
  }
  ngOnInit(): void {
    this.prepareData();
    this.prs.fetchNewRes.subscribe((r) => {
      if (r) {
        this.prepareData();
      }
    })
  }
  @Output() clearParentList = new EventEmitter();
  clearList() {
    this.dataSource.data = [];
    this.clearParentList.emit();
  }
}
